// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selection-popup_modal__e-FOk {
    --padding-left: 45px;

    width: 100%;
    height: calc(100vh - var(--header-height));

    position: fixed;
    top: var(--header-height);
    left: 0;
    background: rgba(251, 251, 251, 1);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    padding: 24px var(--padding-left) 34px;
    z-index: 100;
    display: flex;
    justify-content: center;
    overflow: auto;
    transition: padding 0.4s;

    padding-left: calc(var(--padding-left) + var(--sidebar-collapsed-width));
}

.selection-popup_modal__e-FOk > div {
    width: 100%;
    max-width: 1880px;
    margin: 0 auto;
}

.selection-popup_modalContent__hCG5b {
    display: grid;
    grid-gap: 35px;
    margin: auto;
    grid-template-columns: 7.5fr 2.5fr;
}

.selection-popup_selectionBox__q659S {
    /*max-width: 1400px;*/
    max-height: calc(100vh - var(--header-height) - 58px);
    min-height: 855px;
    overflow: auto;
    /*margin: 0 auto;*/
    position: relative;
    flex: 1 1;
    display: flex;
    flex-direction: column;
    background: #fbfbfc;
    border-radius: 6px;
    border: 4px double rgba(112, 112, 112, 0.25);
    min-width: 756px;
    padding: 24px 34px 24px;
}

.selection-popup_selectionBoxSmaller__5rvIS {
    flex: unset;
}

.selection-popup_selectionBox__q659S .selection-popup_selectionBox__q659S {
    /*width: 1114px;*/
    max-height: 90%;
    min-height: calc(100% - 24px);
    /*max-width: 90% !important;*/
}

.selection-popup_selectionBox__q659S.selection-popup_main__UqWd- {
    padding: 0;
}

.selection-popup_selectionBoxInner__HDM-l {
    --padding-x: 34px;
    position: relative;
    padding: 24px var(--padding-x) 30px;
    flex: 1 1;
    /*max-height: 100%;*/
    display: flex;
    flex-direction: column;
}

.selection-popup_selectionBoxInnerClearPadding__GvItv {
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;
}

.selection-popup_selectionBoxInnerClearPB__Ml3d7 {
    padding-bottom: 0;
}

.selection-popup_selectionBox__q659S h3 {
    /*font-size: 18px;*/
    /*margin-bottom: 12px;*/
    /*color: #7b848e;*/
    /*color: #000000;*/
    /*font-weight: 500;*/
}

.selection-popup_selectedBox__r7Hiv {
    /*width: 480px;*/
    margin: 0;
    padding: 24px 21px 30px;
    background: #fbfbfc;
    border-radius: 6px;
    border: 4px double rgba(12, 59, 141, 0.25);
    position: relative;
    display: flex;
    flex-direction: column;
    /*justify-content: space-between;*/
    max-height: calc(100vh - var(--header-height) - 58px);
    min-height: 855px;
    overflow: auto;
    /*max-width: 450px;*/
    min-width: 300px;
}

.selection-popup_selectedBox__r7Hiv .selection-popup_header__6nA1D {
    margin-bottom: 24px;
}

/*.selectedBox h5 {*/
/*    font-size: 18px;*/
/*    font-weight: 500;*/
/*    margin-bottom: 26px;*/
/*    color: #7b848e;*/
/*}*/

.selection-popup_selectedBox__r7Hiv button {
    margin: 0 auto;
}

.selection-popup_response__mLCIK {
    position: fixed;
    transform: translate(0, 0);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
    display: flex;
    z-index: 126;
}

.selection-popup_selectionBoxSmaller__5rvIS {
    margin: 0 auto;
}

@media (min-width: 2000px) {
    .selection-popup_modalContent__hCG5b {
        grid-template-columns: 7.5fr 2.5fr;
    }
}

@media (max-width: 1280px) {
    .selection-popup_modalContent__hCG5b {
        flex-direction: column;
    }

    .selection-popup_selectionBox__q659S {
        /*min-width: 1156px;*/
    }

    .selection-popup_selectionBox__q659S,
    .selection-popup_selectedBox__r7Hiv {
        width: 100%;
    }

    .selection-popup_selectedBox__r7Hiv {
        display: flex;
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .selection-popup_modal__e-FOk {
        --padding-left: 30px;
        padding-right: 30px;
    }

    /*.selectedBox {*/
    /*    min-width: 340px;*/
    /*    width: 27%;*/
    /*}*/

    .selection-popup_modalContent__hCG5b {
        /*width: 1300px;*/
        grid-gap: 20px;
    }

    .selection-popup_selectionBoxSmaller__5rvIS {
        max-width: 650px;
        min-width: 650px;
    }

    .selection-popup_selectionBoxInner__HDM-l {
        --padding-x: 20px;
        padding-bottom: 20px;
    }

    .selection-popup_selectionBoxInner__HDM-l:not(.selection-popup_selectionBoxInnerClearPadding__GvItv) {
        padding-top: 20px;
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]} {
    .selection-popup_selectionBox__q659S {
        /*width: 1400px;*/
        /*min-width: 756px;*/
        /*flex: unset;*/
    }

    .selection-popup_selectionBoxSmaller__5rvIS {
        min-width: 750px;
        max-width: 750px;
    }

    /*.selectedBox {*/
    /*    width: 481px;*/
    /*}*/
}

@media (max-height: 1260px) {
    .selection-popup_selectedBox__r7Hiv,
    .selection-popup_selectionBox__q659S {
        /*margin: 0 auto !important;*/
        min-height: calc(100vh - var(--header-height) - 58px);
        /*max-height: calc(100vh - var(--header);*/
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-min"]} {
    .selection-popup_modal__e-FOk.selection-popup_menuOpen__YURmm {
        padding-left: calc(var(--sidebar-expanded-width) + var(--padding-left));
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/SelectionPopup/SelectionPopupBase/selection-popup.module.css"],"names":[],"mappings":"AAEA;IACI,oBAAoB;;IAEpB,WAAW;IACX,0CAA0C;;IAE1C,eAAe;IACf,yBAAyB;IACzB,OAAO;IACP,kCAAkC;IAClC,2BAA2B;IAC3B,mCAAmC;IACnC,sCAAsC;IACtC,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,cAAc;IACd,wBAAwB;;IAExB,wEAAwE;AAC5E;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,qDAAqD;IACrD,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;IAC5C,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,6BAA6B;IAC7B,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mCAAmC;IACnC,SAAO;IACP,oBAAoB;IACpB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,kCAAkC;IAClC,qDAAqD;IACrD,iBAAiB;IACjB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB,uBAAuB;AACvB,wBAAwB;AACxB,2BAA2B;AAC3B,sBAAsB;AACtB,IAAI;;AAEJ;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,oCAAoC;IACpC,2BAA2B;IAC3B,mCAAmC;IACnC,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,kCAAkC;IACtC;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB,mBAAmB;IACvB;;IAEA,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;IAClB,IAAI;;IAEJ;QACI,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,oBAAoB;QACpB,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA,iBAAiB;IACjB,oBAAoB;IACpB,IAAI;AACR;;AAEA;IACI;;QAEI,6BAA6B;QAC7B,qDAAqD;QACrD,0CAA0C;IAC9C;AACJ;;AAEA;IACI;QACI,uEAAuE;IAC3E;AACJ","sourcesContent":["@value screen-lg-min, screen-md-max, screen-md-min from '../../../breakpoints.css';\n\n.modal {\n    --padding-left: 45px;\n\n    width: 100%;\n    height: calc(100vh - var(--header-height));\n\n    position: fixed;\n    top: var(--header-height);\n    left: 0;\n    background: rgba(251, 251, 251, 1);\n    backdrop-filter: blur(16px);\n    -webkit-backdrop-filter: blur(16px);\n    padding: 24px var(--padding-left) 34px;\n    z-index: 100;\n    display: flex;\n    justify-content: center;\n    overflow: auto;\n    transition: padding 0.4s;\n\n    padding-left: calc(var(--padding-left) + var(--sidebar-collapsed-width));\n}\n\n.modal > div {\n    width: 100%;\n    max-width: 1880px;\n    margin: 0 auto;\n}\n\n.modalContent {\n    display: grid;\n    grid-gap: 35px;\n    margin: auto;\n    grid-template-columns: 7.5fr 2.5fr;\n}\n\n.selectionBox {\n    /*max-width: 1400px;*/\n    max-height: calc(100vh - var(--header-height) - 58px);\n    min-height: 855px;\n    overflow: auto;\n    /*margin: 0 auto;*/\n    position: relative;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    background: #fbfbfc;\n    border-radius: 6px;\n    border: 4px double rgba(112, 112, 112, 0.25);\n    min-width: 756px;\n    padding: 24px 34px 24px;\n}\n\n.selectionBoxSmaller {\n    flex: unset;\n}\n\n.selectionBox .selectionBox {\n    /*width: 1114px;*/\n    max-height: 90%;\n    min-height: calc(100% - 24px);\n    /*max-width: 90% !important;*/\n}\n\n.selectionBox.main {\n    padding: 0;\n}\n\n.selectionBoxInner {\n    --padding-x: 34px;\n    position: relative;\n    padding: 24px var(--padding-x) 30px;\n    flex: 1;\n    /*max-height: 100%;*/\n    display: flex;\n    flex-direction: column;\n}\n\n.selectionBoxInnerClearPadding {\n    padding-top: 0;\n    padding-left: 0;\n    padding-right: 0;\n}\n\n.selectionBoxInnerClearPB {\n    padding-bottom: 0;\n}\n\n.selectionBox h3 {\n    /*font-size: 18px;*/\n    /*margin-bottom: 12px;*/\n    /*color: #7b848e;*/\n    /*color: #000000;*/\n    /*font-weight: 500;*/\n}\n\n.selectedBox {\n    /*width: 480px;*/\n    margin: 0;\n    padding: 24px 21px 30px;\n    background: #fbfbfc;\n    border-radius: 6px;\n    border: 4px double rgba(12, 59, 141, 0.25);\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    /*justify-content: space-between;*/\n    max-height: calc(100vh - var(--header-height) - 58px);\n    min-height: 855px;\n    overflow: auto;\n    /*max-width: 450px;*/\n    min-width: 300px;\n}\n\n.selectedBox .header {\n    margin-bottom: 24px;\n}\n\n/*.selectedBox h5 {*/\n/*    font-size: 18px;*/\n/*    font-weight: 500;*/\n/*    margin-bottom: 26px;*/\n/*    color: #7b848e;*/\n/*}*/\n\n.selectedBox button {\n    margin: 0 auto;\n}\n\n.response {\n    position: fixed;\n    transform: translate(0, 0);\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background: rgba(255, 255, 255, 0.3);\n    backdrop-filter: blur(15px);\n    -webkit-backdrop-filter: blur(15px);\n    display: flex;\n    z-index: 126;\n}\n\n.selectionBoxSmaller {\n    margin: 0 auto;\n}\n\n@media (min-width: 2000px) {\n    .modalContent {\n        grid-template-columns: 7.5fr 2.5fr;\n    }\n}\n\n@media (max-width: 1280px) {\n    .modalContent {\n        flex-direction: column;\n    }\n\n    .selectionBox {\n        /*min-width: 1156px;*/\n    }\n\n    .selectionBox,\n    .selectedBox {\n        width: 100%;\n    }\n\n    .selectedBox {\n        display: flex;\n    }\n}\n\n@media screen-md-max {\n    .modal {\n        --padding-left: 30px;\n        padding-right: 30px;\n    }\n\n    /*.selectedBox {*/\n    /*    min-width: 340px;*/\n    /*    width: 27%;*/\n    /*}*/\n\n    .modalContent {\n        /*width: 1300px;*/\n        grid-gap: 20px;\n    }\n\n    .selectionBoxSmaller {\n        max-width: 650px;\n        min-width: 650px;\n    }\n\n    .selectionBoxInner {\n        --padding-x: 20px;\n        padding-bottom: 20px;\n    }\n\n    .selectionBoxInner:not(.selectionBoxInnerClearPadding) {\n        padding-top: 20px;\n    }\n}\n\n@media screen-lg-min {\n    .selectionBox {\n        /*width: 1400px;*/\n        /*min-width: 756px;*/\n        /*flex: unset;*/\n    }\n\n    .selectionBoxSmaller {\n        min-width: 750px;\n        max-width: 750px;\n    }\n\n    /*.selectedBox {*/\n    /*    width: 481px;*/\n    /*}*/\n}\n\n@media (max-height: 1260px) {\n    .selectedBox,\n    .selectionBox {\n        /*margin: 0 auto !important;*/\n        min-height: calc(100vh - var(--header-height) - 58px);\n        /*max-height: calc(100vh - var(--header);*/\n    }\n}\n\n@media screen-md-min {\n    .modal.menuOpen {\n        padding-left: calc(var(--sidebar-expanded-width) + var(--padding-left));\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-lg-min": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]}`,
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"screen-md-min": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-min"]}`,
	"modal": `selection-popup_modal__e-FOk`,
	"modalContent": `selection-popup_modalContent__hCG5b`,
	"selectionBox": `selection-popup_selectionBox__q659S`,
	"selectionBoxSmaller": `selection-popup_selectionBoxSmaller__5rvIS`,
	"main": `selection-popup_main__UqWd-`,
	"selectionBoxInner": `selection-popup_selectionBoxInner__HDM-l`,
	"selectionBoxInnerClearPadding": `selection-popup_selectionBoxInnerClearPadding__GvItv`,
	"selectionBoxInnerClearPB": `selection-popup_selectionBoxInnerClearPB__Ml3d7`,
	"selectedBox": `selection-popup_selectedBox__r7Hiv`,
	"header": `selection-popup_header__6nA1D`,
	"response": `selection-popup_response__mLCIK`,
	"menuOpen": `selection-popup_menuOpen__YURmm`
};
export default ___CSS_LOADER_EXPORT___;
